<template>
  <div class="app-container">
    <div class="sub-header">
      <!-- 判断横屏显示图片 -->
      <img class="bg-img" v-if="!isHorizontal && theme[2].hasLogo" :src="require(`@/assets/img/${theme[2].imgUrl}/h_bg.jpg`)" >
      <img class="bg-img" v-else :src="require(`@/assets/img/${theme[2].imgUrl}/h_bg_h.png`)" >
      <div class="logo">
        <img v-if="theme[2].hasLogo" :src="require(`@/assets/img/${theme[2].imgUrl}/logo.png`)">
      </div>
      <div class="head-user cell">
        <div class="avatar">
          <img :src="require(`@/assets/img/default_img.png`)">
        </div>
        <div class="bd">
          <h4 class="name">{{status.username}}</h4>
          <p>UID: <span>{{status.uid}}</span></p>
        </div>
        <div class="head_down">
          <mu-button :color="themeConfig.light" :textColor="themeConfig.dark" small @click="refesh">
            <mu-icon left value="cached"></mu-icon>
            刷新
          </mu-button>
        </div>
      </div>
    </div>
    <div class="nav">
      <mu-ripple v-for="(item, index) in init.switch" :key="index" class="mu-ripple-btn btn1"
        :style="activeNav === item ? `border-color: ${themeConfig.dark};color: ${themeConfig.dark}` : null"
        @click="goRoute(item)">
        <div class="icon" :style="activeNav === item && `background: ${themeConfig.dark};`" v-if="item === 'account'"><img :src="require('@/assets/img/Syg_icon_zgg.png')"></div>
        <div class="icon" :style="activeNav === item && `background: ${themeConfig.dark};`" v-if="item === 'gift'"><img :src="require('@/assets/img/Syg_icon_lib.png')"></div>
        <div class="icon" :style="activeNav === item && `background: ${themeConfig.dark};`" v-if="item === 'announcement'"><img :src="require('@/assets/img/Syg_icon_gds.png')"></div>
        <div class="icon" :style="activeNav === item && `background: ${themeConfig.dark};`" v-if="item === 'news'"><img :src="require('@/assets/img/Syg_icon_zxign.png')"></div>
        <div class="icon" :style="activeNav === item && `background: ${themeConfig.dark};`" v-if="item === 'customer'"><img :src="require('@/assets/img/Syg_icon_kfe.png')"></div>
          <p>{{item === 'account' ? '账号' : item === 'gift' ? '礼包' : item === 'announcement' ? '公告' : item === 'news' ? '资讯' : '客服'}}</p>
          <div class="icon-box">
            <mu-icon value="expand_more" size="16" :color="activeNav === item ? themeConfig.dark : '#C8C8CD'"></mu-icon>
          </div>
      </mu-ripple>
    </div>
    <div class="flex-content" id="ib">
      <div class="nav_h" :style="`height: ${IBHeight}px;`">
        <div class="item-box">
          <mu-ripple class="item" v-for="(item, index) in init.switch" :key="index" @click="goRoute(item)">
            <div class="line" :style="activeNav === item && `background: ${themeConfig.dark};`"></div>
            <div class="icon-box" :style="activeNav === item && `background: ${themeConfig.dark};`" v-if="item === 'account'"><img :src="require('@/assets/img/Syg_icon_zgg.png')"></div>
            <div class="icon-box" :style="activeNav === item && `background: ${themeConfig.dark};`" v-if="item === 'gift'"><img :src="require('@/assets/img/Syg_icon_lib.png')"></div>
            <div class="icon-box" :style="activeNav === item && `background: ${themeConfig.dark};`" v-if="item === 'announcement'"><img :src="require('@/assets/img/Syg_icon_gds.png')"></div>
            <div class="icon-box" :style="activeNav === item && `background: ${themeConfig.dark};`" v-if="item === 'news'"><img :src="require('@/assets/img/Syg_icon_zxign.png')"></div>
            <div class="icon-box" :style="activeNav === item && `background: ${themeConfig.dark};`" v-if="item === 'customer'"><img :src="require('@/assets/img/Syg_icon_kfe.png')"></div>
            <span :style="activeNav === item && `color: ${themeConfig.dark};`">{{item === 'account' ? '账号' : item === 'gift' ? '礼包' : item === 'announcement' ? '公告' : item === 'news' ? '资讯' : '客服'}}</span>
          </mu-ripple>
        </div>
      </div>
      <div class="content-box">
        <user v-if="activeNav === 'account'" :realName="realName" :bindPhoneStatus="bindPhoneStatus" />
        <gift v-if="activeNav === 'gift'" />
        <notice v-if="activeNav === 'announcement'" />
        <information v-if="activeNav === 'news'" />
        <customer v-if="activeNav === 'customer'" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import User from './User'
import Notice from './Notice'
import Information from './Information'
import Customer from './Customer'
import Gift from './Gift'

export default {
  name: 'DrawIndex',
  props: {
    realName: {
      type: Boolean,
      default: false
    },
    bindPhoneStatus: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    realName (val) {
      if (val) {
        this.goRoute('account')
      }
    },
    bindPhoneStatus (val) {
      if (val) {
        this.goRoute('account')
      }
    }
  },
  data () {
    return {
      activeNav: 'account',
      IBHeight: 0
    }
  },
  methods: {
    goRoute (num) {
      this.activeNav = num
    },
    refesh () {
      location.reload()
    },
    download () {
      // window.location.href = this.$store.getters.init.game_info.download_url
    }
  },
  components: {
    User,
    Notice,
    Information,
    Customer,
    Gift
  },
  computed: {
    ...mapGetters([
      'status',
      'theme',
      'init',
      'isHorizontal',
      'themeConfig'
    ])
  },
  mounted () {
    this.goRoute('account')
    this.$nextTick(() => {
      setTimeout(() => {
        if (this.isHorizontal) {
          this.IBHeight = window.innerHeight - document.getElementById('ib').offsetTop
        }
      }, 400)
      window.addEventListener('orientationchange', () => {
        if (!this.IBHeight) {
          setTimeout(() => {
            this.IBHeight = window.innerHeight - document.getElementById('ib').offsetTop
          }, 800)
        }
      })
    })
  }
}
</script>

<style lang="less" scoped>
.sub-header {
  position: relative;
  .bg-img {
    display: block;
    width: 100%;
  }
  .logo {
    position: absolute;
    left: 50%;
    top: .26rem;
    width: 5rem;
    margin-left: -2.5rem;
    img {
      display: block;
      width: 100%;
    }
  }
  .head-user {
    padding: .3rem;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    color: #fff;
    line-height: 1.4;
    img {
      display: block;
      width: 100%;
    }
    .avatar {
      width: .78rem;
      height: .78rem;
      border-radius: 50%;
      border: .03rem solid #fff;
      overflow: hidden;
      margin-right: .1rem;
    }
    .bd {
      flex: 1;
    }
    .name {
      margin: 0;
      font-size: .28rem;
      font-weight: normal;
    }
  }
}
.nav {
  padding: .3rem .1rem;
  display: flex;
  justify-content: space-between;
  .mu-ripple-btn {
    position: relative;
    flex: 1;
    margin: 0 .1rem;
    height: 1.5rem;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    background-color: #fff;
    border-radius: 4px;
    border: 1.2px solid #e5e5e5;
    font-size: .20rem;
    color: #333;
    .icon {
      width: .45rem;
      height: .45rem;
      border-radius: 80%;
      position: relative;
      background: #B7B5B2;
      img {
        display: block;
        width: 60%;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
      }
    }
    .icon-box {
      margin-bottom: -0.15rem;
    }
    .icon_lb {
      background-position: -.48rem 0;
    }
    .icon_gg {
      background-position: -.96rem 0;
    }
    .icon_zc {
      background-position: -1.44rem 0;
    }
    .icon_kf {
      background-position: -1.92rem 0;
    }
    .icon_id {
      background-position: 0 0;
    }
    &.btn-1 {
      color: #2196f3;
      border: 1px solid #2196f3;
    }
  }
}
.flex-content {
  display: flex;
  background: #F8F8F8;
  .nav_h {
    display: none;
    background: #F8F8F8;
    width: 20%;
    position: relative;
    .item-box {
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .item {
        height: 100%;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        border-bottom: 1px solid #fff;
        .icon-box {
          width: .44rem;
          height: .44rem;
          border-radius: 80%;
          position: relative;
          background: #B7B5B2;
          img {
            display: block;
            width: 60%;
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            margin: auto;
          }
        }
        span {
          font-size: .24rem;
          color: #393531;
          margin-left: .1rem;
          display: block;
        }
      }
      .line {
        height: 100%;
        width: .04rem;
        position: absolute;
        left: 0;
        top: 0;
      }
    }
  }
  .content-box {
    width: 100%;
    background: #fff;
  }
}
.cell {
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  align-items: center;
}
</style>
